export default "__VITE_ASSET__b4b9e537__"